import { ThemeColors } from "../types";
import { palette } from "./palette";

/**
 * Light theme tokens.
 *
 * These values intentionally match the application's existing (current,
 * pre-dark-mode) hardcoded colors so introducing the theme system does not
 * visually change the app in Light mode. Values are sourced from the most
 * widely used existing colors (App.tsx root background, AdminColors, and
 * common component styles such as TextArea/LhButton) rather than a redesign.
 */
export const lightThemeColors: ThemeColors = {
  background: {
    page: palette.contentBgLight,
    surface: palette.white,
    elevated: palette.elevatedLight,
  },
  text: {
    primary: palette.gray800,
    secondary: palette.gray450,
    disabled: palette.disabledLight,
    inverse: palette.white,
  },
  border: {
    default: palette.gray100,
    divider: palette.gray50,
  },
  brand: {
    primary: palette.blue700,
  },
  input: {
    background: palette.white,
    border: palette.inputBorderLight,
  },
  button: {
    primaryBackground: palette.blue700,
    primaryText: palette.white,
    secondaryBackground: palette.white,
    secondaryText: palette.blue700,
    disabledBackground: palette.gray50,
    disabledText: palette.gray200,
  },
  status: {
    success: palette.green400,
    warning: palette.amber,
    error: palette.red700,
    info: palette.infoBlue,
  },
  statusBackground: {
    info: palette.infoBgLight,
    success: palette.successBgLight,
    warning: palette.warningBgLight,
    error: palette.errorBgLight,
  },
  overlay: palette.overlayLight,
  cardSelected: {
    border: palette.selectedCardBorderLight,
    background: palette.selectedCardBgLight,
    // Matches the existing kpiValueNegative red exactly, so selected-card
    // value text and the card border use the same red in Light mode.
    text: palette.selectedCardBorderLight,
  },
};
